import React from "react";

import LoginFeature from "../features/auth/LoginWrapper";

function Login(props) {
  return <LoginFeature {...props} />;
}

export default Login;
